import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPhoneVolume,
  faHome,
  faTimes,
  faBars,
  faMapMarked,
  faAngleDown,
  faAngleUp,
  faAngleRight,
  faAngleLeft,
  faMapMarkedAlt,
  faSearch
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

library.add(
  faPhoneVolume,
  faHome,
  faTimes,
  faBars,
  faMapMarked,
  faAngleDown,
  faAngleUp,
  faAngleRight,
  faAngleLeft,
  faMapMarkedAlt,
  faSearch
);
export default FontAwesomeIcon;
